// extracted by mini-css-extract-plugin
export default {"wrapper":"jy9F5Us6sTfCEwcryoTg","tabs":"BO8tu4QqREiBU8YdZfyw"};